import { useSelector } from 'react-redux'

import { getResults, getIsLoading, getIsError, getIdapsDrug } from '../store/modules/idaps/selectors'

/**
 * @description returns idaps drugs
 * @returns
 */
export const useIdaps = () => {
  return useSelector(getResults)
}

/**
 * @description returns if the store is currently loading idaps
 * @returns
 */
export const useIsLoading = () => {
  return useSelector(getIsLoading)
}

/**
 * @description returns idaps error
 * @returns
 */
export const useIsError = () => {
  return useSelector(getIsError)
}

/**
 * @description returns idaps drug
 * @returns
 */
export const useIdapsDrug = () => {
  return useSelector(getIdapsDrug)
}
